module.exports = new __parcel__URL__("shop_cosmetics_button.1d63aea9.png").toString();